import { render, staticRenderFns } from "./sicknesscategorydetails.vue?vue&type=template&id=bddaa78a&scoped=true"
import script from "./sicknesscategorydetails.vue?vue&type=script&lang=js"
export * from "./sicknesscategorydetails.vue?vue&type=script&lang=js"
import style0 from "./sicknesscategorydetails.vue?vue&type=style&index=0&id=bddaa78a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bddaa78a",
  null
  
)

export default component.exports